'use client';

import React, { FC, useCallback, useContext } from 'react';
import type { VariantProps } from 'class-variance-authority';

import { Button, buttonVariants } from 'components/ui/button';

import { useAuth } from 'contexts/auth';
import { MemberContext } from '../../_context/Member';
import { UserConnectType } from 'app/(authenticated)/(member)/_context/Member/Member';


interface IConnectButton {
  user: UserConnectType;
  size?: VariantProps<typeof buttonVariants>['size'];
  classname?: string;
  variant?: VariantProps<typeof buttonVariants>['variant'];
  disabled?: boolean;
}

export const ConnectButton: FC<IConnectButton> = (props) => {
  const { variant, size, user, disabled, classname } = props;
  const { currentUser } = useAuth();

  const { setAction, setConnectModalUser } = useContext(MemberContext);

  const handleConnect = useCallback(() => {
    setConnectModalUser(user ?? null);
    setAction(() => 'connect');
  }, [setAction, setConnectModalUser, user]);

  return currentUser && user && currentUser.id !== user.id ? (
    <Button
      className={classname ?? ''}
      variant={variant}
      size={size}
      disabled={disabled}
      onClick={handleConnect}
    >
      {disabled ? 'Pending' : 'Connect'}
    </Button>
  ) : (
    <></>
  );
};
